module.exports = __webpack_public_path__ + "static/media/2_2_A.27721994.png";